var editor_2d = require("editor-2d");

//Not sure if this is right....
var drawSilkscreenOfFootprintDescriptionTo2D = function (svg, topGroup, bottomGroup, data, onTopLayer) {
    var attrs = {
    };
    if(onTopLayer == null) onTopLayer = true;
    var topG = svg.group(topGroup, attrs);
    var bottomG = svg.group(bottomGroup, attrs);

    data.silkscreen.forEach(function(k, element) {
        if(element.layerIndex.getOne() == onTopLayer){
            if(bottomGroup) editor_2d.drawShapeDataTo2D(svg, bottomG, element.shape());
        }else {
            if(topGroup) editor_2d.drawShapeDataTo2D(svg, topG, element.shape());
        }
    });
};

module.exports = drawSilkscreenOfFootprintDescriptionTo2D;
